/* EducationAI language switcher (eai-i18n) · Lund Studio LLC
   Translates every visible block, stray text and label on the page from a per-language dictionary, keeps each
   page element (and its event listeners) in place, sets lang and dir, switches the font stack by script, and
   remembers the visitor's choice. Dynamic content is translated as it appears. No outside requests.

   Keys: each translatable block is written as a "placeholder string": its text with every inline element replaced
   by a numbered tag, <1>…</1> or <2/> for empty ones (br, img, wbr), whitespace collapsed. The key is a hash of that
   string. A translation is the same string in another language: same numbered tags, same nesting, order may change. */
(function () {
  'use strict';
  if (window.EAI_I18N) return;
  var STORE = 'eai-lang';
  var PHRASING = { A: 1, ABBR: 1, B: 1, BDI: 1, BDO: 1, BR: 1, CITE: 1, CODE: 1, DATA: 1, DFN: 1, EM: 1, I: 1, IMG: 1, KBD: 1,
    MARK: 1, Q: 1, S: 1, SAMP: 1, SMALL: 1, SPAN: 1, STRONG: 1, SUB: 1, SUP: 1, TIME: 1, U: 1, VAR: 1, WBR: 1, ABBR2: 1 };
  var VOID = { BR: 1, IMG: 1, WBR: 1 };
  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEMPLATE: 1, svg: 1, SVG: 1, PRE: 1, TEXTAREA: 1, INPUT: 1, SELECT: 1,
    IFRAME: 1, CANVAS: 1, VIDEO: 1, AUDIO: 1, OBJECT: 1, MATH: 1 };
  var ATTRS = ['alt', 'title', 'aria-label', 'placeholder', 'aria-description'];
  var LETTER = /[A-Za-zÀ-ɏ]/;

  function hash(str) {                       /* cyrb53, base 36 */
    var h1 = 0xdeadbeef, h2 = 0x41c6ce57;
    for (var i = 0, ch; i < str.length; i++) {
      ch = str.charCodeAt(i);
      h1 = Math.imul(h1 ^ ch, 2654435761); h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
    h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);
    return (4294967296 * (2097151 & h2) + (h1 >>> 0)).toString(36);
  }
  function norm(s) { return s.replace(/\s+/g, ' ').trim(); }
  function esc(s) { return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function unesc(s) { return s.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&'); }

  function skipped(el) {
    return el.nodeType === 1 && (SKIP[el.tagName] || el.closest('[translate="no"],.notranslate,[data-i18n-skip],.eai-lang-ui'));
  }
  function phrasingOnly(el) {
    var all = el.getElementsByTagName('*');
    for (var i = 0; i < all.length; i++) if (!PHRASING[all[i].tagName]) return false;
    return true;
  }
  function hasLetters(el) { return LETTER.test(el.textContent); }

  /* the placeholder string of a block, and its elements in the same (preorder) numbering */
  function encode(el) {
    var n = 0, els = [];
    function walk(node) {
      var out = '';
      for (var c = node.firstChild; c; c = c.nextSibling) {
        if (c.nodeType === 3) out += esc(c.data);
        else if (c.nodeType === 1) {
          var k = ++n; els[k] = c;
          out += VOID[c.tagName] ? '<' + k + '/>' : '<' + k + '>' + walk(c) + '</' + k + '>';
        }
      }
      return out;
    }
    return { s: norm(walk(el)), els: els };
  }
  /* parse a translated placeholder string into a tree: {kids:[text|{k, kids}]} */
  function parse(s) {
    var root = { kids: [] }, stack = [root], re = /<(\/?)(\d+)(\/?)>/g, last = 0, m;
    while ((m = re.exec(s))) {
      if (m.index > last) stack[stack.length - 1].kids.push(unesc(s.slice(last, m.index)));
      var k = +m[2];
      if (m[1]) { if (stack.length > 1) stack.pop(); }
      else { var node = { k: k, kids: [] }; stack[stack.length - 1].kids.push(node); if (!m[3]) stack.push(node); }
      last = re.lastIndex;
    }
    if (last < s.length) stack[stack.length - 1].kids.push(unesc(s.slice(last)));
    return root;
  }
  /* rebuild a block's children in the translated order, moving (not recreating) the original elements */
  function mapInto(parentEl, tree, els) {
    var want = tree.kids, i;
    for (i = 0; i < want.length; i++) if (typeof want[i] !== 'string' && !els[want[i].k]) return false;
    var frag = document.createDocumentFragment();
    for (i = 0; i < want.length; i++) {
      var w = want[i];
      if (typeof w === 'string') { if (w) frag.appendChild(document.createTextNode(w)); }
      else {
        var el = els[w.k];
        if (!VOID[el.tagName]) { if (mapInto(el, w, els) === false) return false; }
        frag.appendChild(el);
      }
    }
    while (parentEl.firstChild) parentEl.removeChild(parentEl.firstChild);
    parentEl.appendChild(frag);
    return true;
  }

  /* a string with numbers in it also has a template form: each run of digits outside the tags becomes {1}, {2}…
     so "Lesson 12 of 17" and "Lesson 3 of 17" share one translation */
  function template(src) {
    var nums = [];
    var tpl = src.replace(/(<\/?\d+\/?>)|(\d+(?:[.,:]\d+)*)/g, function (m, tag, num) { if (tag) return tag; nums.push(num); return '{' + nums.length + '}'; });
    return nums.length ? { tpl: tpl, nums: nums } : null;
  }
  function lookup(d, src) {
    var R = window.EAI_I18N_REC, h = hash(src);
    var t = d[h]; if (t) { if (R) R[h] = 1; return t; }
    var T = template(src); if (!T) return null;
    h = hash(T.tpl); t = d[h]; if (!t) return null;
    if (R) R[h] = 1;
    return t.replace(/\{(\d+)\}/g, function (_, i) { return T.nums[i - 1] !== undefined ? T.nums[i - 1] : ''; });
  }

  var state = { lang: 'en', dict: null, touched: [], busy: false, obs: null, langs: [], cache: {} };

  function remember(node, kind, attr) {
    if (kind === 'block' && node.__eaiO === undefined) { node.__eaiO = Array.prototype.slice.call(node.childNodes); node.__eaiOS = null; }
    if (kind === 'text' && node.__eaiO === undefined) node.__eaiO = node.data;
    if (kind === 'attr') { node.__eaiA = node.__eaiA || {}; if (!(attr in node.__eaiA)) node.__eaiA[attr] = node.getAttribute(attr); }
    if (state.touched.indexOf(node) < 0) state.touched.push(node);
  }
  function restoreAll() {
    state.touched.forEach(function (node) {
      if (node.nodeType === 3 && node.__eaiO !== undefined) node.data = node.__eaiO;
      if (node.nodeType === 1) {
        if (node.__eaiO !== undefined) {
          var orig = node.__eaiO;
          while (node.firstChild) node.removeChild(node.firstChild);
          orig.forEach(function (c) { node.appendChild(c); });
          if (node.__eaiTexts) node.__eaiTexts.forEach(function (p) { p[0].data = p[1]; });
          delete node.__eaiO; delete node.__eaiTexts;
        }
        if (node.__eaiA) { for (var a in node.__eaiA) { if (node.__eaiA[a] === null) node.removeAttribute(a); else node.setAttribute(a, node.__eaiA[a]); } delete node.__eaiA; }
      }
      delete node.__eaiL;
    });
    state.touched = [];
  }

  /* walk a subtree: yield blocks (phrasing-only elements with letters), stray text nodes, and attributes */
  function scan(root, visit) {
    function walk(el) {
      if (el.nodeType !== 1 || skipped(el)) return;
      ATTRS.forEach(function (a) { var v = el.getAttribute(a); if (v && LETTER.test(v)) visit('attr', el, a, norm(v)); });
      if (el.__eaiL) return;
      if (el !== document.body && phrasingOnly(el) && hasLetters(el)) {
        var e = encode(el), handled = e.s ? visit('block', el, e, e.s) : false;
        var imgs = el.getElementsByTagName('img');
        for (var j = 0; j < imgs.length; j++) { var alt = imgs[j].getAttribute('alt'); if (alt && LETTER.test(alt)) visit('attr', imgs[j], 'alt', norm(alt)); }
        if (handled !== false) return;
      }
      for (var c = el.firstChild; c; c = c.nextSibling) {
        if (c.nodeType === 3) { if (LETTER.test(c.data) && !c.__eaiL) visit('text', c, null, norm(c.data)); }
        else walk(c);
      }
    }
    walk(root);
  }

  function translateIn(root) {
    var d = state.dict; if (!d) return;
    state.busy = true;
    scan(root, function (kind, node, extra, src) {
      var t = lookup(d, src); if (!t) return false;
      if (kind === 'attr') { remember(node, 'attr', extra); node.setAttribute(extra, t); }
      else if (kind === 'text') {
        remember(node, 'text');
        var lead = node.data.match(/^\s*/)[0], tail = node.data.match(/\s*$/)[0];
        node.data = lead + unesc(t) + tail; node.__eaiL = state.lang;
      } else {
        var texts = []; (function keep(n) { for (var c = n.firstChild; c; c = c.nextSibling) { if (c.nodeType === 3) texts.push([c, c.data]); else keep(c); } })(node);
        remember(node, 'block');
        node.__eaiTexts = texts;
        if (mapInto(node, parse(t), extra.els) === false) {
          var orig = node.__eaiO; while (node.firstChild) node.removeChild(node.firstChild); orig.forEach(function (c) { node.appendChild(c); });
        }
        node.__eaiL = state.lang;
      }
      return true;
    });
    state.busy = false;
  }

  function fontFor(code) {
    var L = state.langs.filter(function (x) { return x.code === code; })[0] || {};
    return L;
  }
  function setDocLang(code) {
    var L = fontFor(code), html = document.documentElement;
    html.lang = code; html.dir = L.dir || 'ltr';
    html.setAttribute('data-eai-script', L.script || 'Latn');
    var btn = document.querySelectorAll('.eai-lang-current');
    for (var i = 0; i < btn.length; i++) btn[i].textContent = L.native || 'English';
    var sh = document.querySelectorAll('.eai-lang-short');
    for (var j = 0; j < sh.length; j++) sh[j].textContent = (code.split('-')[0] || 'en').toUpperCase();
  }

  function loadDict(code) {
    if (state.cache[code]) return Promise.resolve(state.cache[code]);
    var inline = document.getElementById('eai-lang-' + code);
    if (inline) { var j = JSON.parse(inline.textContent); state.cache[code] = j.m || j; return Promise.resolve(state.cache[code]); }
    var base = window.EAI_LANG_BASE;
    if (!base) return Promise.reject(new Error('no dictionary for ' + code));
    var url = base.replace(/eai-lang-[A-Za-z-]+\.json/, 'eai-lang-' + code + '.json');
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (j) { state.cache[code] = j.m || j; return state.cache[code]; });
  }

  function observe() {
    if (state.obs) return;
    var pending = null;
    state.obs = new MutationObserver(function (muts) {
      if (state.busy || state.lang === 'en') return;
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1 && !n.__eaiL) { (pending = pending || []).push(n); }
          else if (n.nodeType === 3 && n.parentNode && !n.parentNode.__eaiL) { (pending = pending || []).push(n.parentNode); }
        });
        if (m.type === 'characterData' && m.target.parentNode && !m.target.__eaiL) (pending = pending || []).push(m.target.parentNode);
      });
      if (pending && !observe.t) observe.t = setTimeout(function () {
        var list = pending; pending = null; observe.t = 0;
        list.forEach(function (n) { if (n.isConnected) translateIn(n.nodeType === 1 ? n : n.parentNode); });
      }, 30);
    });
    state.obs.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  function apply(code) {
    restoreAll();
    state.lang = code; setDocLang(code);
    try { localStorage.setItem(STORE, code); } catch (e) {}
    document.dispatchEvent(new CustomEvent('eai:lang', { detail: { lang: code } }));
    if (code === 'en') { state.dict = null; return Promise.resolve(); }
    return loadDict(code).then(function (d) {
      if (state.lang !== code) return;
      state.dict = d;
      translateIn(document.body);
      if (document.title && d[hash(norm(document.title))]) { document.__eaiTitle = document.__eaiTitle || document.title; document.title = d[hash(norm(document.__eaiTitle))]; }
      observe();
    }).catch(function () { /* no dictionary yet: stay in English, keep the choice */ });
  }

  function hasDone(el) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_ALL), n;
    while ((n = w.nextNode())) if (n.__eaiL) return true;
    return false;
  }
  /* extraction (used by the build tools): every source string the page would ask for */
  function extract() {
    var seen = {}, out = [];
    var d = state.dict || {};
    scan(document.body, function (kind, node, extra, src) {
      if (lookup(d, src)) return true;                       /* already translated in the current language */
      if (kind === 'block' && hasDone(node)) return false;   /* partly translated already: collect only its parts */
      var T = template(src), use = T ? T.tpl : src, k = hash(use);
      if (!seen[k]) {
        seen[k] = 1;
        var sec = (node.nodeType === 1 ? node : node.parentNode).closest('section[id],header,footer,[id]');
        out.push({ k: k, s: use, kind: kind, where: sec ? (sec.id || sec.tagName.toLowerCase()) : '' });
      }
      return false;                                          /* keep walking: collect the parts as well */
    });
    if (document.title) { var t = norm(document.title); var k = hash(t); if (!seen[k]) out.push({ k: k, s: t, kind: 'title', where: 'head' }); }
    return out;
  }

  /* the switcher: a button that opens a searchable list of languages, each in its own script */
  function buildUI() {
    var css = document.createElement('style');
    css.textContent = '.eai-lang-btn{display:inline-flex;align-items:center;gap:.4em;min-height:44px;min-width:44px;padding:0 .8em;border:1px solid #D7DFEE;border-radius:999px;background:#fff;color:#0B1B33;font:600 .95rem/1 Inter,system-ui,-apple-system,"Segoe UI",Roboto,sans-serif;cursor:pointer;white-space:nowrap}.eai-lang-short{display:none}@media (max-width:520px){.eai-lang-btn .eai-lang-current{display:none}.eai-lang-short{display:inline}.eai-lang-btn{padding:0 .6em}}' +
      '.eai-lang-btn:hover{border-color:#1F48C9}.eai-lang-btn:focus-visible{outline:3px solid #1F48C9;outline-offset:2px}.eai-lang-btn svg{width:18px;height:18px;flex:none}' +
      '.eai-lang-dlg{border:0;border-radius:16px;padding:0;font-family:Inter,system-ui,-apple-system,"Segoe UI",Roboto,sans-serif;width:min(560px,calc(100vw - 32px));max-height:min(80vh,720px);color:#0B1B33;background:#fff;box-shadow:0 20px 60px rgba(11,27,51,.25)}' +
      '.eai-lang-dlg::backdrop{background:rgba(11,27,51,.45)}.eai-lang-head{display:flex;gap:8px;align-items:center;padding:16px;border-bottom:1px solid #D7DFEE;position:sticky;top:0;background:#fff}' +
      '.eai-lang-head input{flex:1;min-height:44px;border:1px solid #D7DFEE;border-radius:10px;padding:0 12px;font:inherit;font-size:1rem;color:#0B1B33}' +
      '.eai-lang-head button{min-height:44px;min-width:44px;border:1px solid #D7DFEE;border-radius:10px;background:#fff;font:inherit;cursor:pointer;color:#0B1B33}' +
      '.eai-lang-list{list-style:none;margin:0;padding:8px;display:grid;grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:6px;overflow:auto;max-height:calc(min(80vh,720px) - 80px)}' +
      '.eai-lang-list button{width:100%;min-height:52px;text-align:start;border:1px solid #D7DFEE;border-radius:10px;background:#fff;padding:6px 12px;font:inherit;cursor:pointer;color:#0B1B33;display:grid;gap:2px}' +
      '.eai-lang-list button small{color:#3A4A66;font-size:.8rem}.eai-lang-list button[aria-current="true"]{border-color:#1F48C9;background:#F3F6FD;box-shadow:inset 0 0 0 1px #1F48C9}' +
      '.eai-lang-note{margin:0;padding:10px 16px 16px;font-size:.85rem;color:#3A4A66;border-top:1px solid #D7DFEE}' +
      'html[data-eai-script="Arab"] body{font-family:"Noto Naskh Arabic","Noto Sans Arabic","Geeza Pro","Segoe UI","Tahoma",sans-serif}' +
      'html[data-eai-script="Hebr"] body{font-family:"Noto Sans Hebrew","Arial Hebrew","Segoe UI",Arial,sans-serif}' +
      'html[data-eai-script="Deva"] body{font-family:"Noto Sans Devanagari","Kohinoor Devanagari","Nirmala UI","Mangal",sans-serif}' +
      'html[data-eai-script="Beng"] body{font-family:"Noto Sans Bengali","Kohinoor Bangla","Nirmala UI","Vrinda",sans-serif}' +
      'html[data-eai-script="Guru"] body{font-family:"Noto Sans Gurmukhi","Mukta Mahee","Nirmala UI","Raavi",sans-serif}' +
      'html[data-eai-script="Gujr"] body{font-family:"Noto Sans Gujarati","Kohinoor Gujarati","Nirmala UI","Shruti",sans-serif}' +
      'html[data-eai-script="Telu"] body{font-family:"Noto Sans Telugu","Kohinoor Telugu","Nirmala UI","Gautami",sans-serif}' +
      'html[data-eai-script="Taml"] body{font-family:"Noto Sans Tamil","Tamil Sangam MN","Nirmala UI","Latha",sans-serif}' +
      'html[data-eai-script="Thai"] body{font-family:"Noto Sans Thai","Thonburi","Leelawadee UI","Tahoma",sans-serif}' +
      'html[data-eai-script="Ethi"] body{font-family:"Noto Sans Ethiopic","Kefa","Nyala","Ebrima",sans-serif}' +
      'html[data-eai-script="Khmr"] body{font-family:"Noto Sans Khmer","Khmer Sangam MN","Leelawadee UI","Khmer UI",sans-serif}' +
      'html[data-eai-script="Hans"] body{font-family:"Noto Sans SC","PingFang SC","Hiragino Sans GB","Microsoft YaHei",sans-serif}' +
      'html[data-eai-script="Hant"] body{font-family:"Noto Sans TC","PingFang TC","Microsoft JhengHei",sans-serif}' +
      'html[data-eai-script="Jpan"] body{font-family:"Noto Sans JP","Hiragino Sans","Yu Gothic","Meiryo",sans-serif}' +
      'html[data-eai-script="Kore"] body{font-family:"Noto Sans KR","Apple SD Gothic Neo","Malgun Gothic",sans-serif}' +
      'html[lang="ur"] body{font-family:"Noto Nastaliq Urdu","Jameel Noori Nastaleeq","Urdu Typesetting","Noto Naskh Arabic","Geeza Pro",sans-serif;line-height:1.85}' +
      'html:not([data-eai-script="Latn"]) body *{letter-spacing:normal}html[dir="rtl"] .eai-lang-list button{text-align:right}';
    document.head.appendChild(css);
    var globe = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9.2" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M2.8 12h18.4M12 2.8c2.6 2.6 3.9 5.6 3.9 9.2s-1.3 6.6-3.9 9.2M12 2.8C9.4 5.4 8.1 8.4 8.1 12s1.3 6.6 3.9 9.2" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';
    var dlg = document.createElement('dialog');
    dlg.className = 'eai-lang-dlg'; dlg.setAttribute('aria-label', 'Language');
    var items = state.langs.map(function (L) {
      return '<li><button type="button" lang="' + L.code + '" dir="' + (L.dir || 'ltr') + '" data-lang="' + L.code + '"><span>' + L.native + '</span>' + (L.native !== L.name ? '<small lang="en" dir="ltr">' + L.name + '</small>' : '') + '</button></li>';
    }).join('');
    dlg.innerHTML = '<div class="eai-lang-head"><input type="search" aria-label="Find a language" placeholder="Language · Idioma · 语言 · भाषा · اللغة"><button type="button" class="eai-lang-close" aria-label="Close">✕</button></div><ul class="eai-lang-list notranslate" translate="no">' + items + '</ul>' +
      '<p class="eai-lang-note">Translations are provided for your convenience. If a translation and the English differ, the English governs.</p>';
    document.body.appendChild(dlg);
    var search = dlg.querySelector('input');
    search.addEventListener('input', function () {
      var q = search.value.toLowerCase();
      dlg.querySelectorAll('.eai-lang-list li').forEach(function (li) { li.hidden = q && li.textContent.toLowerCase().indexOf(q) < 0; });
    });
    dlg.querySelector('.eai-lang-close').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) {
      var b = e.target.closest('[data-lang]'); if (b) { apply(b.getAttribute('data-lang')); mark(); dlg.close(); }
      else if (e.target === dlg) dlg.close();
    });
    function mark() { dlg.querySelectorAll('[data-lang]').forEach(function (b) { b.setAttribute('aria-current', String(b.getAttribute('data-lang') === state.lang)); }); }
    function open() { mark(); search.value = ''; search.dispatchEvent(new Event('input')); if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); }
    var mounts = document.querySelectorAll('[data-eai-lang-mount]');
    if (!mounts.length) { var h = document.querySelector('.header-inner') || document.body; var m = document.createElement('div'); m.setAttribute('data-eai-lang-mount', ''); h.appendChild(m); mounts = [m]; }
    Array.prototype.forEach.call(mounts, function (m) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'eai-lang-btn eai-lang-ui notranslate';
      b.setAttribute('aria-haspopup', 'dialog'); b.setAttribute('aria-label', 'Language');
      b.innerHTML = globe + '<span class="eai-lang-current">English</span><span class="eai-lang-short">EN</span>';
      b.addEventListener('click', open); m.appendChild(b);
    });
  }

  function pick() {
    var q = (location.search.match(/[?&]lang=([A-Za-z-]+)/) || [])[1], saved = null;
    try { saved = localStorage.getItem(STORE); } catch (e) {}
    var codes = state.langs.map(function (l) { return l.code; });
    if (q && codes.indexOf(q) >= 0) return q;
    if (saved && codes.indexOf(saved) >= 0) return saved;
    var shop = (window.EAI_SHOP_LOCALE || '').toLowerCase();
    if (shop && shop !== 'en') {
      var i, alias = { 'zh-hk': 'zh-tw', 'zh-mo': 'zh-tw', 'zh-hant': 'zh-tw', 'zh-hans': 'zh-cn', 'zh-sg': 'zh-cn', tl: 'fil' };
      shop = alias[shop] || shop;
      for (i = 0; i < codes.length; i++) { if (codes[i].toLowerCase() === shop) return codes[i]; }                       /* exact first (zh-TW is not zh-CN) */
      for (i = 0; i < codes.length; i++) { if (codes[i].toLowerCase().split('-')[0] === shop.split('-')[0]) return codes[i]; }
    }
    return 'en';                                     /* English until the visitor chooses; their choice is remembered */
  }

  function init() {
    var reg = document.getElementById('eai-langs');
    state.langs = reg ? JSON.parse(reg.textContent) : (window.EAI_LANGS || [{ code: 'en', name: 'English', native: 'English', dir: 'ltr' }]);
    var avail = window.EAI_LANG_AVAILABLE;          /* only list languages whose dictionary ships with this build */
    if (avail) state.langs = state.langs.filter(function (l) { return l.code === 'en' || avail.indexOf(l.code) >= 0; });
    buildUI();
    var code = pick(); if (code !== 'en') apply(code); else setDocLang('en');
  }

  window.EAI_I18N = { apply: apply, extract: extract, hash: hash, norm: norm, encode: encode, current: function () { return state.lang; } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
